module.exports = __webpack_public_path__ + "static/media/10.9ad20b08.png";